import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    value: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
export const userReducer = userSlice.reducer;

const pinSlice = createSlice({
  name: "pin",
  initialState: {
    value: false,
  },
  reducers: {
    setPin: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setPin } = pinSlice.actions;
export const pinReducer = pinSlice.reducer;

const walletSlice = createSlice({
  name: "user",
  initialState: {
    value: 0,
  },
  reducers: {
    setWallet: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setWallet } = walletSlice.actions;
export const walletReducer = walletSlice.reducer;
